import http from '@/http'
import createCrudModule from 'vuex-crud'

export default createCrudModule({
  client: http,
  resource: 'profile/organizations/action',
  urlRoot: 'profile/organizations/action',

  // PUT /organizations/action/{id}/draft
  // PUT /organizations/action/{id}/moderate
  //
  mutations: {
    updateComplete(state) {
      state.isUpdating = false
    }
  },

  actions: {
    update({ commit }, { id, data, config } = {}) {
      commit('updateStart')
      return http
        .post(`profile/organizations/action/${id}`, data, config)
        .then(res => {
          commit('updateSuccess', res)
          return res
        })
        .catch(err => {
          commit('updateError', err)
          return Promise.reject(err)
        })
    },

    createEmpty({ commit }, params) {
      commit('updateStart')
      return http
        .get('profile/organizations/action/create', { params })
        .finally(() => commit('updateComplete'))
    },

    changeStatus({ commit }, { id, status }) {
      commit('updateStart')
      return http
        .put(`profile/organizations/action/${id}/${status}`)
        .finally(() => commit('updateComplete'))
    }
  }
})
